import { useFormContext } from "react-hook-form";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import { openModal } from "../../../../store/redux/slice/ComponentsControl/groupsControl";
import PortalSearchTable from "../../common/table/PortalSearchTable";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import React from "react";
import { SecurityRole, SecurityGuard, OptionTableCell, TableButton } from "@duosoftbg/nacid-components";

const headCells = [
  {
    id: "number",
    label: "l.table.head.number",
    sortable: false,
  },
  {
    id: "name",
    label: "l.table.head.person.name",
  },
  {
    id: "description",
    label: "l.table.head.description",
    sortable: false,
  },
  {
    id: "options",
    label: "",
    sortable: false,
  },
];
const GroupsListTable = ({ records, total, onPageOrOrderChange, blockTable, group }) => {
  const { getValues } = useFormContext();
  const dispatch = useAppDispatch();

  const handleOpenModal = (id, modalType) => {
    const payload = { id, modalType };
    dispatch(openModal(payload));
  };

  return (
    <>
      <PortalSearchTable
        group={group}
        headCells={headCells}
        total={total}
        blockTable={blockTable}
        onPageOrOrderChange={onPageOrOrderChange}
      >
        <TableBody>
          {records.map((row, index) => {
            return (
              <TableRow hover key={row.id}>
                <TableCell>{index + 1 + getValues().page * getValues().pageSize}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.description}</TableCell>
                <OptionTableCell>
                  <TableButton type={"view"} onClick={() => handleOpenModal(row.id, "view")} />
                  <SecurityGuard checkForRoles={[SecurityRole.AcGroupsEdit]}>
                    <TableButton type={"edit"} onClick={() => handleOpenModal(row.id, "edit")} />
                  </SecurityGuard>
                  {/*<SecurityGuard checkForRoles={[SecurityRole.AcGroupsDelete]}>*/}
                  {/*  <TableButton type={"delete"} onClick={() => handleOpenModal(row.id, "delete")} />*/}
                  {/*</SecurityGuard>*/}
                </OptionTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </PortalSearchTable>
    </>
  );
};

export default GroupsListTable;
